export const hasInvalidJwtToken = ({
  response: {
    data: { code, message },
  },
}) => {
  return (
    code === 401 &&
    (message === 'Invalid JWT Token' ||
      message === 'Expired JWT Token' ||
      message === 'JWT Refresh Token Not Found')
  );
};
